import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import Button from '../elements/Button';

const propTypes = {
  ...SectionSplitProps.types,
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

class HeroSplit extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      invertMobile,
      invertDesktop,
      alignTop,
      imageFill,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'hero section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'hero-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    return (
      <div style={heroWrapStyle}>
        <section
          {...props}
          className={outerClasses}
        >
          <div className="container">
            <div className={innerClasses}>
              <div className="hero-center-content">
                <div className="hero-badge reveal-from-top" data-reveal-delay="100">
                  Healthcare Technology &amp; Business Consulting
                </div>
                <h1 className="mt-16 mb-24 reveal-from-top hero-headline" data-reveal-delay="200">
                  Technology Built for<br />
                  <span className="hero-highlight">Insurance &amp; Healthcare</span>
                </h1>
                <p className="hero-subtext mb-40 reveal-from-top" data-reveal-delay="350">
                  Autonomy Resources specializes in building modern technology solutions for insurance agents,
                  brokers, and healthcare organizations. From quoting platforms to CRM integrations—we power
                  the businesses that protect people.
                </p>
                <div className="hero-cta reveal-from-top" data-reveal-delay="500">
                  <Button tag="a" color="primary" href="/contact/" wideMobile>
                    Get in Touch
                  </Button>
                  <a href="#services" className="hero-link-btn">
                    Our Services &darr;
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="hero-wave">
          <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#ffffff" />
          </svg>
        </div>
      </div>
    );
  }
}

const heroWrapStyle = {
  position: 'relative',
  background: 'linear-gradient(150deg, #0F172A 0%, #1e3a5f 45%, #0e7490 100%)',
  overflow: 'hidden'
};

HeroSplit.propTypes = propTypes;
HeroSplit.defaultProps = defaultProps;

export default HeroSplit;
